import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Card, CardBody, CardTitle, Col, Container, Form, FormGroup, Label, Row } from "reactstrap"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Date Picker
import { registerLocale, setDefaultLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "assets/scss/datatables.scss"
import "react-phone-number-input/style.css"

import ptBR from "date-fns/locale/pt-BR"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import {
  buscarConfiguracaoDispositivoPorEmpresa,
  cadastrarConfiguracaoDispositivo,
  editarConfiguracaoDispositivo
} from "../../store/auth/profile/actions"
import usePermission from "helpers/permission/usePermission"
import StickerToolbarButtons from "../../components/Common/sticker-toolbar-buttons"
import AlertaSemVinculo from "../../components/Common/alerta-sem-vinculo"
import Loader from "react-loader-spinner"
import FormInputText from "../../components/Common/form-input-text"
import "toastr/build/toastr.min.css"
import moment from "moment-timezone"
import { convertBlobToFile, getCompanies } from "../../helpers/utils"
import toastr from "toastr"
import FormSelectCompany from "../../components/Common/form-select-company"
import { navegarBreadCrumb } from "../../store/navigator/actions"
import FormInputNumber from "../../components/Common/form-input-number"
import FormInputSwitch from "../../components/Common/form-input-switch"
import { withTranslation } from "react-i18next"
import FormInputColor from "../../components/Common/form-input-color"
import { apiBuscarLogoConfiguracaoDispositivo } from "../../helpers/backend_helper"
import avatar from "../../assets/images/users/default-avatar.png"
import Tooltip from "../../components/Common/tooltip"
import FormInputFile from "../../components/Common/form-input-file"

const brazilMoment = (...args) => moment(...args)
registerLocale("ptBR", ptBR)
setDefaultLocale("ptBR")

const CadastroConfiguracaoDispositivo = props => {

  const isInforangra = props.user?.usuario_info
  const isAdmin = props.user?.usuario_info && props.user?.usuario_info?.perfil?.administrador
  const usePermissionEdit = usePermission("configuracaoDispositivo_editar") && isInforangra
  const usePermissionInsert = usePermission("configuracaoDispositivo_inserir") && isInforangra
  const possuiVinculo = (props.user?.vinculos || []).some(vinculo => ["A", "T"].includes(vinculo.vinculo_status))

  const [loading, setLoading] = useState(false)

  const [companies, setCompanies] = useState([{ label: "Todas", value: "" }])
  const [empresaId, setEmpresaId] = useState()  // INTEGER
  const [id, setId] = useState()  // STRING(10)
  const [corPrimaria, setCorPrimaria] = useState()  // STRING(10)
  const [contrastePrimaria, setContrastePrimaria] = useState()  // STRING(10)
  const [toolbarBackgroundColor, setToolbarBackgroundColor] = useState()  // STRING(10)
  const [toolbarTextColor, setToolbarTextColor] = useState()  // STRING(10)
  const [toolbarPedidoItemBackgroundColor, setToolbarPedidoItemBackgroundColor] = useState()  // STRING(10)
  const [toolbarPedidoItemColor, setToolbarPedidoItemColor] = useState()  // STRING(10)
  const [exibirCarroselInferiorDestaques, setExibirCarroselInferiorDestaques] = useState(true)  // BOOLEAN
  const [cardapioBotaoBackground, setCardapioBotaoBackground] = useState()  // STRING(10)
  const [cardapioBotaoTextColor, setCardapioBotaoTextColor] = useState()  // STRING(10)
  const [cardapioGrupoBackground, setCardapioGrupoBackground] = useState()  // STRING(10)
  const [cardapioGrupoColor, setCardapioGrupoColor] = useState()  // STRING(10)
  const [cardapioGrupoSelecionadoBackground, setCardapioGrupoSelecionadoBackground] = useState()  // STRING(10)
  const [cardapioGrupoSelecionadoColor, setCardapioGrupoSelecionadoColor] = useState()  // STRING(10)
  const [produtoAddBackground, setProdutoAddBackground] = useState()  // STRING(10)
  const [produtoAddColor, setProdutoAddColor] = useState()  // STRING(10)
  const [produtoAddSelecionadoBackground, setProdutoAddSelecionadoBackground] = useState()  // STRING(10)
  const [produtoAddSelecionadoColor, setProdutoAddSelecionadoColor] = useState()  // STRING(10)
  const [produtoAddTituloColor, setProdutoAddTituloColor] = useState()  // STRING(10)
  const [produtoAddDescricaoColor, setProdutoAddDescricaoColor] = useState()  // STRING(10)
  const [produtoAddItensBackground, setProdutoAddItensBackground] = useState()  // STRING(10)
  const [produtoAddItensColor, setProdutoAddItensColor] = useState()  // STRING(10)
  const [menuColor, setMenuColor] = useState()  // STRING(10)
  const [menuSelecionadoColor, setMenuSelecionadoColor] = useState()  // STRING(10)
  const [tempoAtualizacaoCardapio, setTempoAtualizacaoCardapio] = useState()  // INTEGER
  const [tempoEsperaCarrinho, setTempoEsperaCarrinho] = useState()  // INTEGER
  const [configLocalPorta, setConfigLocalPorta] = useState()  // INTEGER
  const [configLocalEnderecoApi, setConfigLocalEnderecoApi] = useState()  // STRING(500)
  const [configLocalToken, setConfigLocalToken] = useState()  // STRING(255)
  const [configLocalPodeVisualizarConsumo, setConfigLocalPodeVisualizarConsumo] = useState(true)  // BOOLEAN
  const [configLocalPodeFecharConta, setConfigLocalPodeFecharConta] = useState(true)  // BOOLEAN
  const [configLocalPodeUsarComanda, setConfigLocalPodeUsarComanda] = useState(true)  // BOOLEAN
  const [configLocalExigirComanda, setConfigLocalExigirComanda] = useState(true)  // BOOLEAN
  const [configLocalAposFechamentoSolicitarAtendente, setConfigLocalAposFechamentoSolicitarAtendente] = useState(false)  // BOOLEAN
  const [logoArquivo, setLogoArquivo] = useState()
  const [alterouLogo, setAlterouLogo] = useState(false)

  useEffect(() => {
    const tmpCompanies = getCompanies(props.user)
    setCompanies(tmpCompanies)

    const empresaId = tmpCompanies[0].value
    setEmpresaId(empresaId)
    props.buscarConfiguracaoDispositivoPorEmpresa({ empresaId }, props.history)
    return () => {
      setCompanies([])
      setEmpresaId(null)
    }
  }, [])

  useEffect(async () => {
    setAlterouLogo(false);
    if(empresaId) {
      try {
        const logoResponse = await apiBuscarLogoConfiguracaoDispositivo(empresaId)
        if (logoResponse && logoResponse.size > 0) {
          const imageBytes = await logoResponse.arrayBuffer();
          const blob = new Blob([imageBytes], { type: "image/jpeg" });
          const logoFile = convertBlobToFile(blob, "logo.jpg", {
            type: "image/jpeg"
          });
          setLogoArquivo({ file: logoFile, nome: logoFile.name } )
        } else {
          setLogoArquivo(null)
        }
      } catch (e) {
        console.error(e);
        setLogoArquivo(null)
      }
    }
    return () => {
      setLogoArquivo(null)
    }
  }, [empresaId])

  const setAlterarLogo = (logo) => {
    setLogoArquivo(logo)
    setAlterouLogo(true);
  }
  const preencherFormulario = (configuracao) => {
    setId(configuracao?.id)
    setCorPrimaria(configuracao ? configuracao?.cor_primaria : null)
    setContrastePrimaria(configuracao?.contraste_cor_primaria)
    setToolbarBackgroundColor(configuracao?.toolbar_background_color)
    setToolbarTextColor(configuracao?.toolbar_text_color)
    setToolbarPedidoItemBackgroundColor(configuracao?.toolbar_pedido_item_background_color)
    setToolbarPedidoItemColor(configuracao?.toolbar_pedido_item_color)
    setExibirCarroselInferiorDestaques(configuracao?.exibir_carrosel_inferior_destaques)
    setCardapioBotaoBackground(configuracao?.cardapio_botao_background)
    setCardapioBotaoTextColor(configuracao?.cardapio_botao_text_color)
    setCardapioGrupoBackground(configuracao?.cardapio_grupo_background)
    setCardapioGrupoColor(configuracao?.cardapio_grupo_color)
    setCardapioGrupoSelecionadoBackground(configuracao?.cardapio_grupo_selecionado_background)
    setCardapioGrupoSelecionadoColor(configuracao?.cardapio_grupo_selecionado_color)
    setProdutoAddBackground(configuracao?.produto_add_background)
    setProdutoAddColor(configuracao?.produto_add_color)
    setProdutoAddSelecionadoBackground(configuracao?.produto_add_selecionado_background)
    setProdutoAddSelecionadoColor(configuracao?.produto_add_selecionado_color)
    setProdutoAddTituloColor(configuracao?.produto_add_titulo_color)
    setProdutoAddDescricaoColor(configuracao?.produto_add_descricao_color)
    setProdutoAddItensBackground(configuracao?.produto_add_itens_background)
    setProdutoAddItensColor(configuracao?.produto_add_itens_color)
    setMenuColor(configuracao?.menu_color)
    setMenuSelecionadoColor(configuracao?.menu_selecionado_color)
    setTempoAtualizacaoCardapio(configuracao?.tempo_atualizacao_cardapio)
    setTempoEsperaCarrinho(configuracao?.tempo_espera_carrinho)
    setConfigLocalPorta(configuracao?.config_local_porta)
    setConfigLocalEnderecoApi(configuracao?.config_local_endereco_api)
    setConfigLocalToken(configuracao?.config_local_token)
    setConfigLocalPodeVisualizarConsumo(configuracao?.config_local_pode_visualizar_consumo)
    setConfigLocalPodeFecharConta(configuracao?.config_local_pode_fechar_conta)
    setConfigLocalPodeUsarComanda(configuracao?.config_local_pode_usar_comanda)
    setConfigLocalExigirComanda(configuracao?.config_local_exigir_comanda)
    setConfigLocalAposFechamentoSolicitarAtendente(configuracao?.config_local_apos_fechamento_solicitar_atendente)
  }

  const gravarConfiguracaoDispositivo = async (e) => {

    let valid = true
    const empresaValid = empresaId !== undefined
    valid = valid && empresaValid

    if (valid) {
      const configuracaoDispositivo = props.configuracaoDispositivo ? Object.assign({}, props.configuracaoDispositivo) : {}

      configuracaoDispositivo.id = id
      configuracaoDispositivo.id_empresa = empresaId
      configuracaoDispositivo.cor_primaria = corPrimaria && typeof corPrimaria === "string" ? corPrimaria?.toUpperCase() : corPrimaria
      configuracaoDispositivo.contraste_cor_primaria = contrastePrimaria && typeof contrastePrimaria === "string" ? contrastePrimaria?.toUpperCase() : contrastePrimaria
      configuracaoDispositivo.toolbar_background_color = toolbarBackgroundColor && typeof toolbarBackgroundColor === "string" ? toolbarBackgroundColor?.toUpperCase() : toolbarBackgroundColor
      configuracaoDispositivo.toolbar_text_color = toolbarTextColor && typeof toolbarTextColor === "string" ? toolbarTextColor?.toUpperCase() : toolbarTextColor
      configuracaoDispositivo.toolbar_pedido_item_background_color = toolbarPedidoItemBackgroundColor && typeof toolbarPedidoItemBackgroundColor === "string" ? toolbarPedidoItemBackgroundColor?.toUpperCase() : toolbarPedidoItemBackgroundColor
      configuracaoDispositivo.toolbar_pedido_item_color = toolbarPedidoItemColor && typeof toolbarPedidoItemColor === "string" ? toolbarPedidoItemColor?.toUpperCase() : toolbarPedidoItemColor
      configuracaoDispositivo.cardapio_botao_background = cardapioBotaoBackground && typeof cardapioBotaoBackground === "string" ? cardapioBotaoBackground?.toUpperCase() : cardapioBotaoBackground
      configuracaoDispositivo.cardapio_botao_text_color = cardapioBotaoTextColor && typeof cardapioBotaoTextColor === "string" ? cardapioBotaoTextColor?.toUpperCase() : cardapioBotaoTextColor
      configuracaoDispositivo.cardapio_grupo_background = cardapioGrupoBackground && typeof cardapioGrupoBackground === "string" ? cardapioGrupoBackground?.toUpperCase() : cardapioGrupoBackground
      configuracaoDispositivo.cardapio_grupo_color = cardapioGrupoColor && typeof cardapioGrupoColor === "string" ? cardapioGrupoColor?.toUpperCase() : cardapioGrupoColor
      configuracaoDispositivo.cardapio_grupo_selecionado_background = cardapioGrupoSelecionadoBackground && typeof cardapioGrupoSelecionadoBackground === "string" ? cardapioGrupoSelecionadoBackground?.toUpperCase() : cardapioGrupoSelecionadoBackground
      configuracaoDispositivo.cardapio_grupo_selecionado_color = cardapioGrupoSelecionadoColor && typeof cardapioGrupoSelecionadoColor === "string" ? cardapioGrupoSelecionadoColor?.toUpperCase() : cardapioGrupoSelecionadoColor
      configuracaoDispositivo.produto_add_background = produtoAddBackground && typeof produtoAddBackground === "string" ? produtoAddBackground?.toUpperCase() : produtoAddBackground
      configuracaoDispositivo.produto_add_color = produtoAddColor && typeof produtoAddColor === "string" ? produtoAddColor?.toUpperCase() : produtoAddColor
      configuracaoDispositivo.produto_add_selecionado_background = produtoAddSelecionadoBackground && typeof produtoAddSelecionadoBackground === "string" ? produtoAddSelecionadoBackground?.toUpperCase() : produtoAddSelecionadoBackground
      configuracaoDispositivo.produto_add_selecionado_color = produtoAddSelecionadoColor && typeof produtoAddSelecionadoColor === "string" ? produtoAddSelecionadoColor?.toUpperCase() : produtoAddSelecionadoColor
      configuracaoDispositivo.produto_add_titulo_color = produtoAddTituloColor && typeof produtoAddTituloColor === "string" ? produtoAddTituloColor?.toUpperCase() : produtoAddTituloColor
      configuracaoDispositivo.produto_add_descricao_color = produtoAddDescricaoColor && typeof produtoAddDescricaoColor === "string" ? produtoAddDescricaoColor?.toUpperCase() : produtoAddDescricaoColor
      configuracaoDispositivo.produto_add_itens_background = produtoAddItensBackground && typeof produtoAddItensBackground === "string" ? produtoAddItensBackground?.toUpperCase() : produtoAddItensBackground
      configuracaoDispositivo.produto_add_itens_color = produtoAddItensColor && typeof produtoAddItensColor === "string" ? produtoAddItensColor?.toUpperCase() : produtoAddItensColor
      configuracaoDispositivo.menu_color = menuColor && typeof menuColor === "string" ? menuColor?.toUpperCase() : menuColor
      configuracaoDispositivo.menu_selecionado_color = menuSelecionadoColor && typeof menuSelecionadoColor === "string" ? menuSelecionadoColor?.toUpperCase() : menuSelecionadoColor
      
      configuracaoDispositivo.exibir_carrosel_inferior_destaques = exibirCarroselInferiorDestaques
      configuracaoDispositivo.config_local_apos_fechamento_solicitar_atendente = configLocalAposFechamentoSolicitarAtendente
      configuracaoDispositivo.config_local_pode_usar_comanda = configLocalPodeUsarComanda
      configuracaoDispositivo.config_local_exigir_comanda = configLocalExigirComanda
      configuracaoDispositivo.config_local_pode_fechar_conta = configLocalPodeFecharConta
      configuracaoDispositivo.config_local_pode_visualizar_consumo = configLocalPodeVisualizarConsumo
      configuracaoDispositivo.tempo_atualizacao_cardapio = tempoAtualizacaoCardapio
      configuracaoDispositivo.tempo_espera_carrinho = tempoEsperaCarrinho
      configuracaoDispositivo.config_local_porta = configLocalPorta
      configuracaoDispositivo.config_local_endereco_api = configLocalEnderecoApi
      configuracaoDispositivo.config_local_token = configLocalToken

      if(alterouLogo) {
        if(logoArquivo) {
          configuracaoDispositivo.logoArquivo = logoArquivo.base64SemPrefixo
        } else {
          configuracaoDispositivo.logo = null
        }
      }

      if (configuracaoDispositivo.id) {
        props.editarConfiguracaoDispositivo(configuracaoDispositivo, props.history)
      } else {
        configuracaoDispositivo.versao_app_atual = '' // valor não exibido em tela e precisa ter um valor default
        props.cadastrarConfiguracaoDispositivo(configuracaoDispositivo, props.history)
      }
    } else {
      const divs = [...document.getElementsByName("validate-required")]
      for (let i = 0; i < divs.length; i++) {
        divs[i].style.display = "block"
      }

      window.scrollTo(0, 0)
      toastr.error("Há campos obrigatórios não preenchidos ou inválidos!", "Validação de informações")
    }
  }

  useEffect(() => {
    if(props.configuracaoDispositivo) {
      preencherFormulario(props.configuracaoDispositivo)
    } else {
      preencherFormulario(null)
    }
    return () => preencherFormulario(null)
  }, [props.configuracaoDispositivo])

  const alterarEmpresa = value => {
    const empresaId = value ? value : null
    setEmpresaId(empresaId)
    if (value) {
      props.buscarConfiguracaoDispositivoPorEmpresa({ empresaId: value }, props.history)
    }
  }

  if (!props.user || !possuiVinculo) {
    return (<AlertaSemVinculo />)
  }

  return <React.Fragment>
    {props.configuracaoDispositivoLoading || loading ? (<div className="loader-container position-absolute">
      <Loader
        type="ThreeDots"
        color="#556EE6"
        height={80}
        width={80}
      />
    </div>) : (<div className="page-content">
      <Container fluid>
        <Breadcrumbs title="breadcrumb.configuracaoDispositivo.new" />
        <StickerToolbarButtons>
          <Button
            type="submit"
            color="primary"
            className="waves-effect waves-light me-2"
            disabled={!empresaId || !((id && usePermissionEdit) || (!id && usePermissionInsert))
            }
            onClick={e => gravarConfiguracaoDispositivo(e)}>
            {"Salvar configuração"}
          </Button>
        </StickerToolbarButtons>

        <Row>
          <Col lg="12">
            <div>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">{ props.t('breadcrumb.configuracaoDispositivo.new')}</CardTitle>
                  <Form>
                    <div className="outer">
                      <p>
                        { props.t('configuracao-dispositivo.edicao.descritivo') }
                      </p>

                      <div className="outer">

                        <FormSelectCompany
                          attribute="empresaId"
                          value={empresaId}
                          setValue={alterarEmpresa}
                          options={companies.filter(c => c.value)}
                          required={true}
                          labelColumns={3}
                        />

                        <FormInputColor
                          attribute="corPrimaria"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.cor-primaria"
                          value={corPrimaria}
                          setValue={setCorPrimaria}
                          labelColumns={3}
                        />

                        <FormInputColor
                          attribute="contrastePrimaria"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.contraste-primaria"
                          value={contrastePrimaria}
                          setValue={setContrastePrimaria}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="toolbarBackgroundColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.toolbar-background-color"
                          value={toolbarBackgroundColor}
                          setValue={setToolbarBackgroundColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="toolbarTextColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.toolbar-text-color"
                          value={toolbarTextColor}
                          setValue={setToolbarTextColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="toolbarPedidoItemBackgroundColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.toolbar-pedido-item-background-color"
                          value={toolbarPedidoItemBackgroundColor}
                          setValue={setToolbarPedidoItemBackgroundColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="toolbarPedidoItemColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.toolbar-pedido-item-color"
                          value={toolbarPedidoItemColor}
                          setValue={setToolbarPedidoItemColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="cardapioBotaoBackground"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.cardapio-botao-background"
                          value={cardapioBotaoBackground}
                          setValue={setCardapioBotaoBackground}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="cardapioBotaoTextColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.cardapio-botao-text-color"
                          value={cardapioBotaoTextColor}
                          setValue={setCardapioBotaoTextColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="cardapioGrupoBackground"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.cardapio-grupo-background"
                          value={cardapioGrupoBackground}
                          setValue={setCardapioGrupoBackground}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="cardapioGrupoColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.cardapio-grupo-color"
                          value={cardapioGrupoColor}
                          setValue={setCardapioGrupoColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="cardapioGrupoSelecionadoBackground"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.cardapio-grupo-selecionado-background"
                          value={cardapioGrupoSelecionadoBackground}
                          setValue={setCardapioGrupoSelecionadoBackground}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="cardapioGrupoSelecionadoColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.cardapio-grupo-selecionado-color"
                          value={cardapioGrupoSelecionadoColor}
                          setValue={setCardapioGrupoSelecionadoColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="produtoAddBackground"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.produto-add-background"
                          value={produtoAddBackground}
                          setValue={setProdutoAddBackground}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="produtoAddColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.produto-add-color"
                          value={produtoAddColor}
                          setValue={setProdutoAddColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="produtoAddSelecionadoBackground"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.produto-add-selecionado-background"
                          value={produtoAddSelecionadoBackground}
                          setValue={setProdutoAddSelecionadoBackground}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="produtoAddSelecionadoColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.produto-add-selecionado-color"
                          value={produtoAddSelecionadoColor}
                          setValue={setProdutoAddSelecionadoColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="produtoAddTituloColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.produto-add-titulo-color"
                          value={produtoAddTituloColor}
                          setValue={setProdutoAddTituloColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="produtoAddDescricaoColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.produto-add-descricao-color"
                          value={produtoAddDescricaoColor}
                          setValue={setProdutoAddDescricaoColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="produtoAddItensBackground"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.produto-add-itens-background"
                          value={produtoAddItensBackground}
                          setValue={setProdutoAddItensBackground}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="produtoAddItensColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.produto-add-itens-color"
                          value={produtoAddItensColor}
                          setValue={setProdutoAddItensColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="menuColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.menu-color"
                          value={menuColor}
                          setValue={setMenuColor}
                        labelColumns={3} />

                        <FormInputColor
                          attribute="menuSelecionadoColor"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.menu-selecionado-color"
                          value={menuSelecionadoColor}
                          setValue={setMenuSelecionadoColor}
                        labelColumns={3} />

                        <FormInputNumber
                          attribute="tempoAtualizacaoCardapio"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.tempo-atualizacao-cardapio"
                          value={tempoAtualizacaoCardapio}
                          setValue={setTempoAtualizacaoCardapio}
                          required={false}
                        labelColumns={3} />

                        <FormInputNumber
                          attribute="tempoEsperaCarrinho"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.tempo-espera-carrinho"
                          value={tempoEsperaCarrinho}
                          setValue={setTempoEsperaCarrinho}
                          required={false}
                        labelColumns={3} />

                        <FormInputNumber
                          attribute="configLocalPorta"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.config-local-porta"
                          value={configLocalPorta}
                          setValue={setConfigLocalPorta}
                          required={false}
                        labelColumns={3} />

                        <FormInputText
                          attribute="configLocalEnderecoApi"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.config-local-endereco-api"
                          value={configLocalEnderecoApi}
                          setValue={setConfigLocalEnderecoApi}
                          required={false}
                          maxLength={500}
                        labelColumns={3} />

                        <FormInputText
                          attribute="configLocalToken"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.config-local-token"
                          value={configLocalToken}
                          setValue={setConfigLocalToken}
                          required={false}
                          maxLength={255}
                        labelColumns={3} />

                        <FormInputSwitch
                          attribute="exibirCarroselInferiorDestaques"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.exibir-carrossel-inferior-destaques"
                          value={exibirCarroselInferiorDestaques}
                          setValue={setExibirCarroselInferiorDestaques}
                          required={false}
                          labelColumns={3}
                          falseValue={false}
                          trueValue={true}/>

                        <FormInputSwitch
                          attribute="configLocalPodeVisualizarConsumo"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.config-local-pode-visualizar-consumo"
                          value={configLocalPodeVisualizarConsumo}
                          setValue={setConfigLocalPodeVisualizarConsumo}
                          required={false}
                          labelColumns={3}
                          falseValue={false}
                          trueValue={true}/>

                        <FormInputSwitch
                          attribute="configLocalPodeFecharConta"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.config-local-pode-fechar-conta"
                          value={configLocalPodeFecharConta}
                          setValue={setConfigLocalPodeFecharConta}
                          required={false}
                          labelColumns={3}
                          falseValue={false}
                          trueValue={true}/>

                        <FormInputSwitch
                          attribute="configLocalPodeUsarComanda"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.config-local-pode-usar-comanda"
                          value={configLocalPodeUsarComanda}
                          setValue={setConfigLocalPodeUsarComanda}
                          required={false}
                          labelColumns={3}
                          falseValue={false}
                          trueValue={true}/>

                        <FormInputSwitch
                          attribute="configLocalExigirComanda"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.config-local-exigir-comanda"
                          value={configLocalExigirComanda}
                          setValue={setConfigLocalExigirComanda}
                          required={false}
                          labelColumns={3}
                          falseValue={false}
                          trueValue={true}/>

                        <FormInputSwitch
                          attribute="configLocalAposFechamentoSolicitarAtendente"
                          keyTranslate="configuracao-dispositivo.edicao.config-dispositivo.config-local-apos-fechamento-solicitar-atendente"
                          value={configLocalAposFechamentoSolicitarAtendente}
                          setValue={setConfigLocalAposFechamentoSolicitarAtendente}
                          required={false}
                          labelColumns={3}
                          falseValue={false}
                          trueValue={true}/>

                        <FormInputFile
                          attribute="logo"
                          description={ props.t('configuracao-dispositivo.edicao.config-dispositivo.logo.label') }
                          extension={"image/png, image/jpeg"}
                          value={logoArquivo}
                          setValue={setAlterarLogo}
                          loading={ false }
                          removeHandeler={ () => setAlterarLogo(null) }
                          labelColumns={3}/>

                      </div>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>)}
  </React.Fragment>
}

CadastroConfiguracaoDispositivo.propTypes = {
  user: PropTypes.any,
  configuracaoDispositivo: PropTypes.any,
  configuracaoDispositivoLoading: PropTypes.any,
  configuracaoDispositivoAtivo: PropTypes.any,
  buscarConfiguracaoDispositivoPorEmpresa: PropTypes.func,
  cadastrarConfiguracaoDispositivo: PropTypes.func,
  editarConfiguracaoDispositivo: PropTypes.func,
}

const mapStatetoProps = state => {
  const {
    configuracaoDispositivo,
    configuracaoDispositivoAtivo,
    configuracaoDispositivoLoading,
    permanecerCadastro
  } = state.Profile
  const { user } = state.Login
  return {
    user,
    configuracaoDispositivo,
    configuracaoDispositivoLoading,
    configuracaoDispositivoAtivo,
    permanecerCadastro
  }
}

export default withTranslation()(connect(mapStatetoProps, {
  buscarConfiguracaoDispositivoPorEmpresa,
  cadastrarConfiguracaoDispositivo,
  editarConfiguracaoDispositivo,
  navegarBreadCrumb
})(withRouter(CadastroConfiguracaoDispositivo)))

